<script>
import Popup from './popup.vue';

export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    name: "invoiceDetail",
    data() {
        return {};
    },
    computed: {},
    components: {
        Popup
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <Popup title="发票详情" :show="show" isShowClose @close="$emit('close')">
        <template v-if="show">
        <div class="form">
            <div class="item">
                <p class="name">发票抬头</p>
                <p class="value">{{ data.invoice.title }}</p>
            </div>
            <div class="item">
                <p class="name">抬头类型</p>
                <p class="value">{{ data.invoice.type == 1 ? '个人或事业单位' : '企业' }}</p>
            </div>
            <div class="item">
                <p class="name">发票类型</p>
                <p class="value">{{ data.invoice.title_type == 1 ? '普通发票' : '专用发票' }}</p>
            </div>
            <div class="item">
                <p class="name">邮箱</p>
                <p class="value">{{ data.invoice.email }}</p>
            </div>
            <template v-if="data.invoice.type == 2">
                <div class="item">
                    <p class="name">税号</p>
                    <p class="value">{{ data.invoice.tax_number }}</p>
                </div>
                <div class="item">
                    <p class="name">开户银行</p>
                    <p class="value">{{ data.invoice.bank_name }}</p>
                </div>
                <div class="item">
                    <p class="name">银行账号</p>
                    <p class="value">{{ data.invoice.bank_account }}</p>
                </div>
                <div class="item">
                    <p class="name">企业地址</p>
                    <p class="value">{{ data.invoice.address }}</p>
                </div>
                <div class="item">
                    <p class="name">企业电话</p>
                    <p class="value">{{ data.invoice.phone }}</p>
                </div>
            </template>
            <div class="item">
                <p class="name">发票金额</p>
                <p class="value">{{ data.amount }}</p>
            </div>
            <div class="item">
                <p class="name">申请日期</p>
                <p class="value">{{ data.invoice.created_at }}</p>
            </div>
        </div>
        <div class="bottom btn_group flex justify_end" v-if="data.invoice.status == 0">
            <div class="btn big" @click="$emit('cancel', data.order_code)">取消申请</div>
        </div>
        </template>
    </Popup>
</template>

<style scoped lang="scss">
.bottom{
    margin-top: .2rem;
}
.form{
    @media screen and (max-width: 750px) {
        background: #fff;
        padding: .3rem;
        border-radius: .1rem;
    }
}
</style>